const COLORS = {
    blue: "#1A8CFF",
    green: "#78a55a",
    red: "#D75F55",
};

export default COLORS;
